import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { paginateArray } from '../utils'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

const base64ToString = (response) => { 

  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

const getEquipmentsLoan = async (dataOrigen, refrescar, api, token, body, config) => {
  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.equipmentsloan.length <= 0 || data.startDate !== config.startDate || data.endDate !== config.endDate) {
    const response = await axios(configws)
    data = { equipmentsloan: base64ToString(response) }
  }

  // eslint-disable-next-line object-curly-newline
  const { q = '', perPage = 10, page = 1, sort, sortColumn } = config
  /* eslint-enable */

  const dataAsc = data.equipmentsloan.sort((a, b) => {
    if (a[sortColumn]) {
      return a[sortColumn] < b[sortColumn] ? -1 : 1
    } else {
      const splitColumn = sortColumn.split('.')
      const columnA = a[splitColumn[0]][splitColumn[1]]
      const columnB = b[splitColumn[0]][splitColumn[1]]
      return columnA < columnB ? -1 : 1
    }
  })

  const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

  const queryLowered = q.toLowerCase()
  const filteredData = dataToFilter.filter(equipment => {

      return (
        (
          equipment.equipment_loan_datetime.toLowerCase().includes(queryLowered) ||
          equipment.equipment_returned_datetime.toLowerCase().includes(queryLowered) ||
          equipment.executive_id.toLowerCase().includes(queryLowered) ||
          equipment.equipment_code.toLowerCase().includes(queryLowered) ||
          equipment.name.toLowerCase().includes(queryLowered) ||
          String(equipment.loan_status).toLowerCase().includes(queryLowered)
        )
      )
  })

  return [
    200,
    {
      allData: data.equipmentsloan,
      total: filteredData.length,
      equipmentsloan: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page)
    }
  ]  
}

// ------------------------------------------------
// GET: Return list of equipmentsloan
// ------------------------------------------------

let dataEquipmentsLoan = JSON.parse(localStorage.getItem("dataEquipmentLoan")) || { equipmentsloan: [], startDate: '', endDate: ''}

mock.onGet('/apps/equipmentsloan').reply(async config => {
  const user = getUserData()

  if (config.reset) {
    dataEquipmentsLoan = { equipmentsloan: [], startDate: '', endDate: ''}
  }

  const body = {
    page:            1,
    page_size:       '',
    property_filter: '',
    client_filter:   '',
    date_from:       config.startDate,
    date_to:         config.endDate,
    office_id:       user.usercoc.office_id
  }

  const result = await getEquipmentsLoan(dataEquipmentsLoan, 1, GetApiCOC('getlist_equipment_loan'), user.token, body, config)

  dataEquipmentsLoan = { equipmentsloan: result[1].allData, startDate: config.startDate, endDate: config.endDate }

  localStorage.setItem("dataEquipmentLoan", JSON.stringify(dataEquipmentsLoan))

  return result
})

// ------------------------------------------------
// Post: Add equipmentsloan
// ------------------------------------------------
mock.onPost(/\/api\/equipmentsloan\/\d+/).reply(async config => {

  const body = JSON.parse(config.data)

  const configws = {
    method: 'post',
    url:    GetApiCOC('insert_equipment_loan'),
    headers: { 
      Accept:'application/json'
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})